// extracted by mini-css-extract-plugin
export default {"selectStudent":"Students_selectStudent__YV96o"};